
export const enum triggerTypes {
    sensorvalue = "sensorValue",
    timeofday = "timeOfDay",
    manual = "manual",
    interval = "interval",
    event = "event"
}